// extracted by mini-css-extract-plugin
export default {"circle":"circle_circle__QMDD9"};